import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useWaterSystemSearchModal } from '../../../../reuseableComponents/WaterSystemSearchModalContext';

const DwriSystemHeader = ({ systemName, loading }) => {
    const { selectedWaterSystem } = useWaterSystemSearchModal();
    const displayPwsId = selectedWaterSystem?.pwsId
        ? selectedWaterSystem.pwsId.replace('UTAH', '')
        : '';

    const displayName = systemName || selectedWaterSystem?.systemName || (loading ? 'Loading...' : '');

    return (
        <Row className="mt-3">
            <Col>
                <span className="d-inline-block ps-4">
                    <h3 style={{ fontSize: '160%' }}>
                        <b>{displayName}</b>
                    </h3>
                </span>
                <span className="d-inline-block float-end pe-4">
                    <h3 style={{ fontSize: '160%' }}>
                        <b>PWS {displayPwsId}</b>
                    </h3>
                </span>
                <div style={{
                    backgroundColor: 'rgb(20, 121, 149)',
                    margin: '0.1rem 0px 2rem',
                    verticalAlign: 'middle',
                    border: '1px solid lightgrey',
                    borderRadius: '15px',
                    padding: '5px',
                }}></div>
            </Col>
        </Row>
    );
};

export default DwriSystemHeader;
